module.exports = __webpack_public_path__ + "static/media/brush_9.3f0b9759.png";